import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ProjectTemplate } from './models/project-template.model';

const BASE_URL = `${environment.apiConfig.url}/project-templates`;

@Injectable()
export class ProjectTemplateService {
  constructor(private http: HttpClient) {}

  loadTemplates(): Observable<ProjectTemplate[]> {
    return this.http.get<ProjectTemplate[]>(BASE_URL);
  }
}
